import * as braze from '@braze/web-sdk'
import brazeHelper from '~/assets/util/braze'

const DEFAULT_SERVICE_WORKER_PATH = '/braze-service-worker.js'

function getBrazeConfig (env = {}) {
	return env.braze || {}
}

function isBrazeConfigComplete ({ enabled, apiKey, sdkEndpoint }) {
	return Boolean(enabled && apiKey && sdkEndpoint)
}

function registerBrazeServiceWorker (serviceWorkerPath, logger, env) {
	if (typeof navigator === 'undefined' || !navigator.serviceWorker) {
		return
	}
	navigator.serviceWorker.register(serviceWorkerPath || DEFAULT_SERVICE_WORKER_PATH).catch((error) => {
		if (!env.isProdEnv) {
			logger.warn('Braze service worker registration failed', error)
		}
	})
}

export default function ({ env, $log }, inject) {
	const brazeConfig = getBrazeConfig(env)
	const logger = $log || console
	if (!isBrazeConfigComplete(brazeConfig)) {
		if (brazeConfig.enabled && !env.isProdEnv) {
			logger.warn('Braze SDK is not configured: missing API key or endpoint')
		}
		inject('brazeClient', brazeHelper.createDisabledBrazeClient())
		return
	}
	try {
		braze.initialize(brazeConfig.apiKey, {
			baseUrl: brazeConfig.sdkEndpoint,
			enableLogging: !env.isProdEnv,
			allowUserSuppliedJavascript: true,
			manageServiceWorkerExternally: true
		})
		braze.automaticallyShowInAppMessages()
		registerBrazeServiceWorker(brazeConfig.serviceWorkerPath, logger, env)
		braze.openSession()
		inject('brazeClient', brazeHelper.createReadyBrazeClient(braze))
	} catch (error) {
		logger.warn('Failed to initialize Braze SDK', error)
		inject('brazeClient', brazeHelper.createDisabledBrazeClient())
	}
}
